import { showSuccessToast } from '@bpinternal/ui-kit-next'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getApiClient } from '~/stores'
import { getQueryKey } from '../../services'

export function useUpdateBotAllowlist() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      botId,
      workspaceId,
      setting,
      users,
    }: {
      botId: string
      workspaceId: string
      setting: 'ALL_WORKSPACE_USERS' | 'SELECTED_USERS'
      users?: Record<string, boolean>
    }) => {
      const apiClient = getApiClient({ workspaceId })

      await apiClient.updateBotAllowlist({
        botId,
        setting,
        users,
      })
    },
    onSuccess: async (_, { botId, workspaceId }) => {
      showSuccessToast('Bot access list updated')
      queryClient.invalidateQueries({
        queryKey: getQueryKey('workspaces_/$workspaceId_/bots_/$botId_/allowlist', { botId, workspaceId }),
      })
    },
  })
}
